class VideoObserver extends HTMLElement {
  #video = null;
  #observer = null;
  #options = {
    threshold: 0.25,
  };

  connectedCallback() {
    const video = this.querySelector('video');
    const options = JSON.parse(this.dataset.options || '{}');

    this.#options = {
      ...this.#options,
      ...options,
    };

    if (!video) return;

    this.#video = video;
    if (this.#video && 'IntersectionObserver' in window) {
      this.#observer = new IntersectionObserver((entries) => this.#observerCallback(entries), {
        threshold: this.#options.threshold,
      });
      this.#observer.observe(this.#video);
    } else if (this.#video) {
      this.#video.play();
    }
  }

  disconnectedCallback() {
    if (this.#observer) this.#observer.disconnect();
  }

  #observerCallback(entries) {
    entries.forEach((entry) => {
      const { target: video } = entry;
      entry.isIntersecting ? video.play() : video.pause();
    });
  }
}

customElements.define('video-observer', VideoObserver);
